module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "resume.689fead0.txt" + "?" + Date.now();